import React from "react";
import {
  RegisterOptions,
  useFormContext,
  useFormState,
  useWatch,
} from "react-hook-form";

import { Textarea, TextareaProps } from "../Textarea";

type Register = Omit<RegisterOptions, "onChange" | "onBlur">;

export type FormTextareaProps = TextareaProps & {
  name: string;
  register?: Register;
};

export const FormTextarea = (props: FormTextareaProps) => {
  const { register } = useFormContext();
  const value = useWatch({ name: props.name, defaultValue: "" });
  const { errors } = useFormState();

  const { pattern, valueAsNumber, valueAsDate, ...restRegisterProp } =
    props.register || {};

  const registerOptions: RegisterOptions = {
    onChange: props.onChange,
    disabled: props.disabled,
    required: props.required,
    ...restRegisterProp,
  };

  // Need to set explicitly to satisfy TS discriminated union.
  // @see node_modules/react-hook-form/dist/types/validator.d.ts
  if (pattern && !valueAsNumber && !valueAsNumber) {
    registerOptions.pattern = pattern;
  } else if (valueAsNumber && !valueAsDate) {
    registerOptions.valueAsNumber = valueAsNumber;
  } else if (valueAsDate) {
    registerOptions.valueAsDate = valueAsDate;
  }

  const utils = register(props.name, registerOptions);

  return (
    <Textarea
      error={Boolean(errors[props.name])}
      {...utils}
      {...props}
      value={value}
      ref={utils.ref}
      onChange={utils.onChange}
      onBlur={utils.onBlur}
    />
  );
};

FormTextarea.displayName = "FormTextarea";

export default FormTextarea;
